
import VueRouter from "vue-router";

const router = new VueRouter({
    routes: [

    ]
})

export default router;